(function(formHelper, Cookies, Porthole, $) {

	if (!formHelper) { throw new Error('formhelper.ipeer.parent requires formHelper'); }
	if (!Cookies)    { throw new Error('formhelper.ipeer.parent requires Cookies.js'); }
	if (!Porthole)   { throw new Error('formhelper.ipeer.parent requires Porthole.js'); }

	formHelper.addIPeerRule = function(rule) {

		rule.requestController   = formHelper.FormHelperIPeerRequest;
		rule.porthole            = null;

		rule.ipeer = rule.ipeer || {};
		rule.ipeer.frame = rule.ipeer.frame || '#peer-iframe';

		formHelper.addRule(rule);

		rule.readyHasBeenAcknowledged  = false;

		function repeatReadyUntilAcknowledged(afterAckFunction, repeatDelay) {
			// console.log('repeatReadyUntilAcknowledged parent');
			// if (afterAckFunction) {
				// console.log('repeatReadyUntilAcknowledged parent - afterAckFunction OK');
			// } else {
				// console.log('repeatReadyUntilAcknowledged parent - afterAckFunction NOT OK');
			// }
			if (! rule.readyHasBeenAcknowledged ){
				rule.porthole.post({event: 'fh-ipeer-ready'});
				// setTimeout(repeatReadyUntilAcknowledged,repeatDelay,afterAckFunction);
				setTimeout(function(){
					repeatReadyUntilAcknowledged(afterAckFunction,repeatDelay)
				},repeatDelay);
				return;
			} else {
				if (afterAckFunction) {
					// console.log('afterAckFunction parent');
					afterAckFunction();
				} else {
					// console.log('readyHasBeenAcknowledged parent - but afterAckFunction no good')
				}
			}
		}


		$(function() {

			var $frame = $(rule.ipeer.frame);

			if (!$frame.length) return;

			var frameName = $frame.attr('name');

			if (!frameName)                { throw new Error('formhelper.ipeer iframe element must have \'name\' attribute'); }
			if (!formHelper.iPeerHostname) { throw new Error('formhelper.ipeer.parent requires formHelper.iPeerHostname to be set'); }

			rule.porthole = new Porthole.WindowProxy( 'https://' + formHelper.iPeerHostname + '/formhelper/porthole/proxy.html', frameName );

			formHelper.portholeSendFHIPeerCustomEvent = function(data) {
				rule.porthole.post({event: 'fh-ipeer-custom-event', "data": data});
			};

			rule.porthole.addEventListener(function(messageEvent) {

				// console.log("from Child: " + messageEvent.data.event);

				var data = messageEvent.data;

				switch (data.event) {

					case 'fh-ipeer-child-resize':
						$(rule.ipeer.frame).height(data.bodyHeight);
						break;

					case 'fh-ipeer-child-submit':
						$(rule.form).submit();
						break;

					case 'fh-ipeer-ready':
						rule.porthole.post({event: 'fh-ipeer-ready-ack'});
						break;

					case 'fh-ipeer-ready-ack':
						rule.readyHasBeenAcknowledged  = true;
						break;
				}
			});

			if (rule.iframe_custom_event_handler){
				rule.porthole.addEventListener(
					function (messageEvent) {
						var data = messageEvent.data;
						if (data.event == 'fh-ipeer-custom-event'){
							rule.iframe_custom_event_handler(data.data);
						}
					}
				);
			}

			// setTimeout(repeatReadyUntilAcknowledged, 0, null, 100);
			setTimeout(function(){repeatReadyUntilAcknowledged(null,100);},0);

		});

	};



	function FormHelperIPeerRequest(formEl, rule, submitEvent) {
		this.iPeerIframeResponse       = null;
		this.porthole                  = rule.porthole;

		this.peerSubmitCompleteHandler = $.proxy(this.peerSubmitCompleteHandler, this);
		this.porthole.addEventListener(this.peerSubmitCompleteHandler);

		this.initialize(formEl, rule, submitEvent);
	}

	FormHelperIPeerRequest.Defaults = {
		rule:       {},
		xhrOptions: {}
	};


	var FormHelperRequest = formHelper.FormHelperRequest;
	FormHelperIPeerRequest.prototype = new FormHelperRequest(null, {});


	$.extend(FormHelperIPeerRequest.prototype, {

		startXHR: function() {

			// Get the form ready to submit...
			this.checkoutForm();
			this.hideAllStatusMessages();
			this.hideAllErrorMessages();
			this.hideAllParamMessages();
			this.clearAllErroredFields();
			this.disableControls();

			// But don't actually submit it yet, just notify the iframe form to do its thing
			this.porthole.post({event: 'fh-ipeer-parent-submit'});

		},

		resumeXHR: function(response) {

			this.iPeerIframeResponse = response;

			this.xhrOptions.data['peer-status'] = response.status || 'UNKNOWN';

			this.savePeerCookies(response.data);

			FormHelperRequest.prototype.startXHR.call(this);
		},

		xhrSuccess: function(data, textStatus, jqXHR) {

			if (this.iPeerIframeResponse) {
				if (this.iPeerIframeResponse.status !== 'SUCCESS') {
					data.status = this.iPeerIframeResponse.status;
				}
				if (this.iPeerIframeResponse.errors) {
					if (data.errors) {
						data.errors = data.errors.concat(this.iPeerIframeResponse.errors);
					} else {
						data.errors = this.iPeerIframeResponse.errors;
					}
				}
			}

			this.porthole.post({event: 'fh-ipeer-parent-response-received', status: data.status});

			FormHelperRequest.prototype.xhrSuccess.call(this, data, textStatus, jqXHR);
		},

		savePeerCookies: function(data) {
			if (!data) return;

			var peerCookies = data.peerCookies;

			if (peerCookies) {
				for (var i = 0, len = peerCookies.length; i < len; i++) {
					var cookie = peerCookies[i];
					Cookies.set(cookie.name, cookie.value, {path: '/'});
				}
			}
		},

		peerSubmitCompleteHandler: function(messageEvent) {
			var data = messageEvent.data;

			switch (data.event) {

				case 'fh-ipeer-child-response-received':
					this.resumeXHR(data.responseData);
					this.porthole.removeEventListener(this.peerSubmitCompleteHandler);
					break;
			}
		},

	});

	formHelper.FormHelperIPeerRequest = FormHelperIPeerRequest;


})(window.formHelper, window.Cookies, window.Porthole, jQuery);



















